import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { useCallback } from 'react';

import { ItemCardLiveBidButton as ItemCardBidButton } from '@/components/GridItemCard/Card/components/ItemCardBidButton/ItemCardLiveBidButton';
import { NewItemCardRegisterLink } from '@/components/GridItemCard/Card/components/NewItemCardRegisterLink/NewItemCardRegisterLink';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
    getRegistrationApproved,
    getRegistrationApprovedWithLimit,
} from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import {
    getItemSummaryBidderHasBid,
    getItemSummaryCatalogId,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { openRetractBidModal } from '@/redux/modules/modal';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export type CardRegistrationProps = {
    isMobile: boolean;
    isOpenItem: boolean;
    itemId: number;
};

export const CardRegistration = ({ isMobile, isOpenItem, itemId }: CardRegistrationProps) => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const bidderHasBid = useAppSelector((state) => getItemSummaryBidderHasBid(state, itemId));
    const approved = useAppSelector((state) => getRegistrationApproved(state, catalogId));
    const approvedWithBidLimit = useAppSelector((state) => getRegistrationApprovedWithLimit(state, catalogId));

    const isApprovedForOpenItem = isOpenItem && (approved || approvedWithBidLimit);

    const openRetractBidModalCallback = useCallback(() => {
        dispatch(openRetractBidModal(itemId));
    }, [dispatch, itemId]);

    return (
        <section
            className="flex [grid-area:registerForAuction]"
            data-testid="timedPlusMyItemsCardRegistration"
        >
            {isApprovedForOpenItem && <ItemCardBidButton itemId={itemId} />}
            {!approved && (
                <NewItemCardRegisterLink
                    catalogId={catalogId}
                    className="w-full xsMax:w-[211px]"
                    itemId={itemId}
                    registerToBidMessageId="registration.register_for_auction_my_items"
                />
            )}
            {isApprovedForOpenItem && bidderHasBid && isMobile && (
                <Button
                    aria-label="retract bid button"
                    className="max-[560px]:px-xs xsMax:px-sm"
                    onClick={openRetractBidModalCallback}
                    size="sm"
                >
                    {formatMessage(['retract'])}
                </Button>
            )}
        </section>
    );
};
